import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSignupReferralList } from "../../Redux/Actions/referralsAction";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { SignUpReferralLists } from "../../Global Functions/columnsAntd";
import TableComponentCp from "../../Global Functions/tableComponentsCp";
import toast from "react-hot-toast";

const SignupListReferrals = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });


  const fetchDetails = useCallback(async (page, limit, showLoader = true) => {
    const referralData = {
      page,
      limit,
      is_deleted: false,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(getSignupReferralList(referralData, showLoader));
      if (!showLoader) {
        toast.success("Referrals list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh referrals list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  );

  const { userReferrals, loading } = useSelector((state) => state.referrals);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDetails(pagination.current, pagination.pageSize);
    }, 150);

    return () => clearTimeout(timer);
  }, [pagination.current, pagination.pageSize, fetchDetails]);


  useEffect(() => {
    if (userReferrals?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: userReferrals.total
      }));
    }
  }, [userReferrals]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const columns = React.useMemo(() => {
    return SignUpReferralLists(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize]);


  return (
    <>
      <TableComponentCp
        h3heading="Sign-Up Referrals List"
        setState={setSearchQuery}
        pagination={pagination}
        onChange={handleTableChange}
        columns={columns}
        dataSource={(Array.isArray(userReferrals?.data) && userReferrals.data) || []}
        loading={loading}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default SignupListReferrals;
